export interface IDesignerInstructionsRequest {

    Name: string;
    Email: string;
    LicenseKey: string;

}

export class DesignerInstructionsRequest implements IDesignerInstructionsRequest {

    Name: string;
    Email: string;
    LicenseKey: string;

}